import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RechargeType } from '@vacationtracker/shared/types/recharge-type'

interface RechargeTypeState {
  rechargeType: RechargeType | null
  completedAt: string | null
  isLoading: boolean
}

const initialState: RechargeTypeState = {
  rechargeType: null,
  completedAt: null,
  isLoading: true,
}

export const rechargeTypeSlice = createSlice({
  name: 'rechargeType',
  initialState,
  reducers: {
    setRechargeType: (
      state,
      action: PayloadAction<{
        rechargeType: RechargeType
        completedAt: string
      }>
    ) => {
      state.rechargeType = action.payload.rechargeType
      state.completedAt = action.payload.completedAt
      state.isLoading = false
    },
    clearRechargeType: (state) => {
      state.rechargeType = null
      state.completedAt = null
      state.isLoading = false
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const { setRechargeType, clearRechargeType, setLoading } =
  rechargeTypeSlice.actions

export default rechargeTypeSlice.reducer


